<template>
  <div class="zujian">
      <el-dialog a title="关联司机" :visible.sync="guanlianMark" @close="closeDialog"  :close-on-click-modal="false" width="900px" center>
      <el-form :inline="true" :model="SJsearchFrom" ref="SJsearchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class=" inpBox">
          <el-form-item label="司机姓名:" prop="name">
            <el-input  placeholder="" v-model.trim="SJsearchFrom.name"></el-input>
          </el-form-item>
          <el-form-item label="身份证号:" prop="identityNo">
            <el-input  placeholder="" v-model.trim="SJsearchFrom.identityNo"></el-input>
          </el-form-item>
              <el-form-item >
            <el-button type="primary" @click="SJsearchFn">查询</el-button>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" @click="resetForm()">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
        <div>
          <el-table :data="SJList" ref="table"  bordersize="mini"
             class="table" height="380px" style="width: 100%"   center  border   >
            <el-table-column  type="index" width="55" label="序号"></el-table-column>
              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <el-button type="text"  @click="guanlianfn(scope.row)" size="mini">关联</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="name" min-width="120" :show-overflow-tooltip="true"  label="司机姓名"></el-table-column>
              <el-table-column prop="mobile" width="150" label="联系电话"></el-table-column>
              <el-table-column property="identityNo" label="身份证号" width="200">
                <template scope="scope">
                  <p v-if="scope.row.tenantId!=tenantCode">
                    {{scope.row.identityNo.replace(/^(.{4})(?:\d+)(.{4})$/, "$1**********$2")}}
                  </p>
                  <p v-else>{{scope.row.identityNo}}</p>
                </template>
              </el-table-column>
          </el-table>
        </div>
         <span slot="footer" class="dialog-footer">
          <el-button @click="guanlianMark=false">关闭</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import { assignDriverList, fleetAddDriver } from '@/api/vgs-driver2.0'
export default {
  name: 'uploadImg',
  data () {
    return {
      guanlianMark: false,
      tenantCode: '',
      SJsearchFrom: {
        pageNo: 1,
        pageSize: 1000
      },
      SJList: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.guanlianMark = true
    this.tenantCode = localStorage.getItem('tenantCode')
  },
  methods: {
    guanlianfn (row) {
      this.$confirm('是否关联司机' + row.name + '?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        fleetAddDriver({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '关联成功',
            type: 'success'
          })
          this.$parent.searchFn()
          this.guanlianMark = false
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 查选
    SJsearchFn () {
      this.SJgetList(this.SJsearchFrom)
    },
    // 获取列表
    SJgetList (searchFrom) {
      assignDriverList(searchFrom).then(res => {
        this.SJList = res.list
        this.SJtotal = res.total
      })
    },
    resetForm () {
      this.SJsearchFrom = {
        pageNo: 1,
        pageSize: 1000
      }
    },
    closeDialog () {
      this.$emit('update:guanlianFlag', false)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
</style>
